'use strict';
(function ()
{
    angular.module("QuartoApp").factory("userService", ['$rootScope', '$http', userService]);

    function userService($rootScope, $http)
    {
        class userSettingInfo
        {
            //default user setting
            ClientCode = "";
            DftRcdNo = 20;
            PageSizeRcd = JSON.stringify([20, 50, 100, 500]);
            CultureKey = 1;
            ThemeKey = 1;
            TimeZone = "Singapore Standard Time";
            langKey = 1;
            lang = "en";
            ID = "";
        };

        let userServiceFactory = {
            userSetting: new userSettingInfo(),
            setUserSetting: function ()
            {
                let that = this;
                return new Promise((resolve, reject) =>
                {
                    $http.get($rootScope.masterWebApiUrl + 'UserSetting/GetUserSetting').then((response) =>
                    {
                        if (Array.isArray(response?.data) && response.data.length > 0)
                        {
                            that.userSetting.ClientCode = response.data[0].ClientCode;
                            that.userSetting.DftRcdNo = +response.data[0].DftRcdNo;
                            that.userSetting.DftRcdNo = that.userSetting.DftRcdNo <= 20 ? 20 : that.userSetting.DftRcdNo;
                            that.userSetting.PageSizeRcd = JSON.stringify(response.data[0].PageSizeRcd);
                            that.userSetting.CultureKey = +response.data[0].CultureKey;
                            that.userSetting.ThemeKey = +response.data[0].ThemeKey;
                            that.userSetting.TimeZone = response.data[0].TimeZone;
                            that.userSetting.langKey = +response.data[0].LangKey;
                            that.userSetting.ID = response.data[0].ID;

                            if (that.userSetting.langKey == 1)
                            {
                                that.userSetting.lang = "en";
                            }
                            else if (that.userSetting.langKey == 2)
                            {
                                that.userSetting.lang = "my";
                            }
                            else if (that.userSetting.langKey == 3)
                            {
                                that.userSetting.lang = "id";
                            }

                            $rootScope.userSetting = that.userSetting;
                            resolve(that.userSetting);
                        }
                        else
                        {
                            reject(error);
                        }
                    }, (error) => reject(error));
                });
            },
            clearUserSetting: function ()
            {
                let that = this;
                that.userSetting = new userSettingInfo();
                $rootScope.userSetting = that.userSetting;
            }
        };

        return userServiceFactory;
    }
})();